(function () {
  if (window.__braletteSizeInit) return;
  window.__braletteSizeInit = true;

  var ERROR_MESSAGE = 'Please enter your bralette size';

  function getErrorEl(input) {
    var wrap = input.closest('[data-bralette-size]');
    return wrap ? wrap.querySelector('[data-bralette-size-error]') : null;
  }

  function showError(input) {
    var err = getErrorEl(input);
    if (err) err.hidden = false;
    input.classList.add('is-invalid');
    input.setAttribute('aria-invalid', 'true');
    try { input.focus({ preventScroll: false }); } catch (_) { try { input.focus(); } catch (__) {} }
    try { input.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
  }

  function clearError(input) {
    var err = getErrorEl(input);
    if (err) err.hidden = true;
    input.classList.remove('is-invalid');
    input.removeAttribute('aria-invalid');
    if (input.setCustomValidity) input.setCustomValidity('');
  }

  // Each bralette input is associated to a product form via its `form`
  // attribute. Strip `novalidate` so the browser blocks submission on
  // empty input — this works for both Add to Cart and Shop Pay / Buy Now
  // because Shopify's payment buttons submit the same form.
  function setup(input) {
    if (input.__braletteReady) return;
    input.__braletteReady = true;

    var formId = input.getAttribute('form');
    var form = formId ? document.getElementById(formId) : input.form;
    if (form) form.removeAttribute('novalidate');

    if (input.setCustomValidity) {
      input.setCustomValidity(input.value ? '' : ERROR_MESSAGE);
    }
  }

  function setupAll() {
    document.querySelectorAll('[data-bralette-size-input]').forEach(setup);
  }

  // Browser fires `invalid` whenever the form's checkValidity() fails.
  // We swallow the native tooltip (preventDefault) and surface our own
  // styled inline error in its place.
  document.addEventListener('invalid', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-bralette-size-input]')) return;
    e.preventDefault();
    showError(input);
  }, true);

  // Shopify's dynamic checkout button (Shop Pay / Buy Now / PayPal /
  // Google Pay etc.) submits the form via JS, which skips the browser's
  // native pre-submit validation. Run validation manually on click and
  // block the event before Shopify's handler runs.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest(
      '.shopify-payment-button,' +
      '.shopify-payment-button__button,' +
      '.shopify-payment-button__more-options,' +
      '[data-shopify="payment-button"] button,' +
      '[data-shopify="payment-button"]'
    );
    if (!trigger) return;

    var pf = trigger.closest('product-form, .product-form');
    var form = pf ? pf.querySelector('form') : trigger.closest('form');
    if (!form) return;
    if (form.checkValidity && form.checkValidity()) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.reportValidity) form.reportValidity();
  }, true);

  // Update validity + error UI as the user types.
  function handleInputChange(e) {
    var input = e.target && e.target.closest && e.target.closest('[data-bralette-size-input]');
    if (!input) return;
    var hasValue = (input.value || '').trim() !== '';
    if (input.setCustomValidity) input.setCustomValidity(hasValue ? '' : ERROR_MESSAGE);
    if (hasValue) clearError(input);
  }
  document.addEventListener('input', handleInputChange);
  document.addEventListener('change', handleInputChange);

  function init() {
    setupAll();
    var quickView = document.querySelector('.js-quick_view');
    var observerTarget = quickView || document.body;
    new MutationObserver(function () { setupAll(); }).observe(
      observerTarget,
      quickView ? { childList: true } : { childList: true, subtree: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
